import { render, staticRenderFns } from "./hongbao.vue?vue&type=template&id=fc419356&scoped=true&"
import script from "./hongbao.vue?vue&type=script&lang=js&"
export * from "./hongbao.vue?vue&type=script&lang=js&"
import style0 from "./hongbao.vue?vue&type=style&index=0&id=fc419356&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc419356",
  null
  
)

export default component.exports